import makeStyles from "@mui/styles/makeStyles";
import {useDispatch} from "react-redux";
import * as React from "react";
import {useEffect} from "react";
import {setSnackbar} from "../../../store/reducers/globals";
import {Button, InputLabel, MenuItem, OutlinedInput, Select, TableCell, TableRow, Typography} from "@mui/material";
import * as _get from "lodash/get";
import {ArrowIconHL7, ErrorIconHL7} from "../../../components/icons/icons";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {styled} from "@mui/styles";
import FormControl from "@mui/material/FormControl";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
    '&.MuiOutlinedInput-root': {
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.25)",
        '&.Mui-focused fieldset': {
            borderColor: "#448FFF",
        },
    },
    // '&.MuiInputBase-input':{
    //     borderRadius: "50%",
    //     '&:focus': {
    //         borderColor: '#448FFF',
    //     }
    // }
}));

const useStyles = makeStyles((theme) => ({
        typeSelect: {
            width: 150,
            height: 50,
            marginLeft: '15px',
        },
        typeSelectItem: {
            '&:hover': {
                backgroundColor: '#448FFF',
                color: 'white',
            }
        },
        agyleButton:{
            background: '#448FFF',
        },
        errorContainer: {
            cursor: "pointer",
            backgroundColor: "#FFECEC",
            maxWidth: "max-content",
            borderRadius: "7px",
            marginBottom: "10px",
        },
        errorIconOuter: {
            minWidth: '85px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '10px',
            marginRight: '10px',
        },
        errorIconInner: {
            height:'40px',
            width: '40px',
            backgroundColor: 'white',
            borderRadius: '50%',
            paddingLeft:'10px',
            paddingTop:'10px',
            boxShadow: '0 0 10px red'
        },
        errorContainerText: {
            marginTop: '20px',
            marginRight: '20px',
            marginBottom: '20px',
            wordBreak: 'initial'
        },
        spaceBetween: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',

        },
        textWithArrow: {
            cursor: "pointer",
            display: 'flex',
            gap: '5px'
        }
    })
)

export const ColumnTypes = {
    TEXT: 1,
    ACTIONS: 2,
    CUSTOM: 3
}

const columnsWidths = {
    "Info": '100px',
    "Date": '300px',
    "Created": '300px',
    "Type": '170px',
    "Hospital number": '170px',
    "Attendance": '200px',
    "System": '200px',
    "Version": '200px',
    "Actions": '200px',
    "Patient": '200px',
    "Status": '170px',
    "Last Send Time": '200px',
    "Last Status": '170px',
    "Hl7 Type": '170px',
};

function AgyleAdminTableRow(props){
    const columns = props.columns;
    const row = props.row;
    const classes = useStyles();

    const dispatch = useDispatch();

    const [messageVisible, setMessageVisible] = React.useState(false);

    const [selected, setSelected] = React.useState(false);

    const handleAddToSelectRows = (row) => {
        setSelected(!selected);
    }

    React.useEffect(()=>{
        if(props.handleAddRow && selected)
            props.handleAddRow(row);
        if(props.handleRemoveRow && !selected)
            props.handleRemoveRow(row);
    }, [selected])

    const handleMessageClick = () => {
        setMessageVisible(!messageVisible);
    }

    const checkMessage = (msg, nm)=> {
        switch(nm.key) {
            case "Copy JSON":
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to copy`, severity: "error"}));
                return nm.props.onClick();

            case "Show JSON":
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to show`, severity: "error"}));
                return nm.props.onClick();

            case "Details":
                return nm.props.onClick();
        }
    }

    return (
        <React.Fragment>
            <TableRow hover role="checkbox" tabIndex={-1} key={row.code + props.rowIndex}>
            {columns.map((column, index) => {
                switch(column.type) {
                    case ColumnTypes.TEXT:
                        const value = _get(row, column.value);
                        return (
                            <TableCell key={props.rowIndex + "_" + index + "_text"} align={column.align}
                                       style={{wordBreak: "break-all"}}>
                                {column.format
                                    ? column.format(value)
                                    : value}
                            </TableCell>
                        );
                    case ColumnTypes.ACTIONS:
                        let buttons = [];
                        column.actionList.forEach((action) => {
                            buttons.push(<Button key={action.buttonLabel}
                                                 onClick={() => action.callback(row)}>{action.buttonLabel}</Button>)
                        })
                        return (
                            <TableCell key={props.rowIndex + "_" + "buttonsAction"} align={column.align}>
                                <StyledFormControl className={classes.typeSelect}>
                                    <InputLabel>Select action</InputLabel>
                                    <Select
                                        input={<OutlinedInput/>}
                                    >
                                        {buttons.map((name) => {
                                            return (
                                                <MenuItem
                                                    className={classes.typeSelectItem}
                                                    key={name.key}
                                                    onClick={() => checkMessage(row.message, name)}
                                                    value="Select action"
                                                >
                                                    {name.key}
                                                </MenuItem>
                                            )
                                        })
                                        }
                                    </Select>
                                </StyledFormControl>
                            </TableCell>
                        );
                    case ColumnTypes.CUSTOM:
                        return (
                            <TableCell key={props.rowIndex + "_" + index + "_custom"} align={column.align}
                                       style={{wordBreak: "break-all"}}>
                                { column.renderer(row) }
                            </TableCell>
                        );
                }
            })}
        </TableRow>
        </React.Fragment>)
}

export default AgyleAdminTableRow;